import { useAtomValue } from 'jotai'
import React from 'react'

import { application as applicationAdmin } from '~/apps/applicationAdmin/application'
import { application as ninesegsAnalyzer } from '~/apps/ninesegsAnalyzer/application'
import { auth0UserAtom } from '~/atoms'
import { useCommonQuery } from '~/hooks/useCommonQuery'
import { type Application, compact, exists } from '~/utils'

export const useAvailableApplications = (): Application[] => {
  const auth0User = useAtomValue(auth0UserAtom)
  const { data } = useCommonQuery()

  return React.useMemo(() => {
    if (!exists(auth0User)) {
      return []
    }

    const isCoreMember = data?.isCoreMember ?? false

    if (isCoreMember === true) {
      return compact([ninesegsAnalyzer, applicationAdmin])
    } else {
      const hasBrandAccounts = data?.brandAccounts
        ? data.brandAccounts.length > 0
        : false

      return compact([hasBrandAccounts && ninesegsAnalyzer])
    }
  }, [auth0User, data?.isCoreMember, data?.brandAccounts])
}
